import React from 'react';

const VerificationQR = ({ reportCardNumber = 'RC-2026-001', size = 'small' }) => {
  const verifyUrl = `${window.location.origin}/verify/report-card/${reportCardNumber}`;
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(verifyUrl)}`;

  const imgSize = size === 'large' ? '70px' : size === 'medium' ? '55px' : '45px';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img src={qrCodeUrl} alt="QR Verification" style={{ width: imgSize, height: imgSize, borderRadius: '4px', border: '1px solid #cbd5e1', padding: '2px' }} />
      <span style={{ fontSize: '7.5px', color: '#64748b', fontWeight: '700', marginTop: '2px', textTransform: 'uppercase' }}>
        Scan to Verify
      </span>
    </div>
  );
};

export default VerificationQR;
